/*
 * @Description: 自定义全局方法
 * @Date: 2020-07-27 11:25:02
 */
import Config from '@/config/index'
import emoji from 'node-emoji'
import SA from '@/public/SA';
import wxShare from '@/public/wxShare' //初始化wx 每次转跳必须初始化一次
import xrkDialog from '@/components/dialog/index.js';
import wx from 'weixin-js-sdk';
import Videojs from 'video.js'; //引入video.js插件
import 'video.js/dist/video-js.css';

export default {
  install (Vue, options) {
    // Vue.prototype.$wxUserInfo = wxSDK;
    // Vue.prototype.$wxSDK = wxSDK;
    Vue.prototype.$wx = wx
    Vue.prototype.$config = Config;
    Vue.prototype.$emoji = emoji;
    Vue.prototype.$sa = new SA();
    Vue.prototype.$wxShare = wxShare
    Vue.prototype.$xrkDialog = xrkDialog;
    Vue.prototype.$video = Videojs;
    
  }
}
